<div class="outer-wrapper">
  <div class="segment"></div>
  <div class="taxonomy-selection">
    <div class="taxonomy-header" [matMenuTriggerFor]="taxonomyMenu" #menuTrigger="matMenuTrigger">
      <div class="taxonomy">
        {{ taxoSelectedValue() }}
      </div>
      <div class="taxonomy-arrow">
        <img src="../../../../assets/icons/arrow_down_grey.svg" alt="arrow-left" class="arrow-left">
      </div>
    </div>
  </div>
</div>

<!-- Dropdown using MatMenu -->
<mat-menu #taxonomyMenu="matMenu" class=".dropdown-content">
  <div matMenuContent (click)="$event.stopPropagation()">
    <!-- Search Box inside Dropdown -->
    <div class="search-container">
      <input matInput [(ngModel)]="searchText" placeholder="Search..." (click)="$event.stopPropagation()">
    </div>

    <!-- Dropdown Options -->
    <button mat-menu-item *ngFor="let option of filteredOptions()"
      (click)="onSelectionChange(option.taxonomy_id); menuTrigger.closeMenu()">
      {{ option.taxonomy_name }}
    </button>

    <!-- No Results Message -->
    <button mat-menu-item disabled *ngIf="filteredOptions().length === 0">
      No results found
    </button>
  </div>
</mat-menu>
